import React, { createContext, useContext, useEffect, useState } from 'react';
import axiosInstance from '../api/axios';
import IdleLogout from '../components/IdleLogout';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      const expired = isTokenExpired(token);
      if (expired) {
        logout();
      } else {
        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      }
    }
    setLoading(false);
  }, [token]);

  const login = (newToken, userInfo) => {
    localStorage.setItem('token', newToken);
    localStorage.setItem('info', JSON.stringify(userInfo));
    axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
    setToken(newToken);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('info');
    // Saved screen state (e.g. patient list search) can contain patient names.
    try { sessionStorage.clear(); } catch (e) { /* ignore */ }
    delete axiosInstance.defaults.headers.common['Authorization'];
    setToken(null);
  };

  const isAuthenticated = !!token && !isTokenExpired(token);

  return (
    <AuthContext.Provider value={{ token, isAuthenticated, login, logout, loading }}>
      {children}
      {isAuthenticated && <IdleLogout onTimeout={logout} />}
    </AuthContext.Provider>
  );
};

// Hook for convenience
export const useAuth = () => useContext(AuthContext);

// ✅ Helper function to check JWT expiry
function isTokenExpired(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (!payload.exp) return false;
    return Date.now() >= payload.exp * 1000; // exp is in seconds
  } catch (e) {
    return true; // treat invalid tokens as expired
  }
}